<div class="container w-100">
    <div *ngIf="!openGroupForm">
        <div class="Tabletitle">
            <span> Groups configured: <span *ngIf="allGroups"> ({{allGroups.data.length}})
        </span> </span>
        </div>

        <!-- <button *ngIf="allGroups" class="actionButton m-1" mat-raised-button (click)="createGroup($event)">Create
      Group</button> -->
        <div *ngIf="allGroups" class="table-container mat-elevation-z8">
            <table mat-table matSort [dataSource]="allGroups" matSortActive="name" aria-describedby="groups-table" matSortDirection="asc">

                <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition"-->

                <!-- Hold Name Column -->
                <ng-container matColumnDef="name">
                    <th id="name" mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                    <td mat-cell *matCellDef="let group"> {{group.GroupName}} </td>
                </ng-container>

                <!-- Description Column -->
                <ng-container matColumnDef="userPoolId">
                    <th id="userPoolId" mat-header-cell *matHeaderCellDef mat-sort-header> User Pool Id </th>
                    <td mat-cell *matCellDef="let group"> {{group.UserPoolId}} </td>
                </ng-container>

                <!--Currently not being used-->
                <!-- Action Column -->
                <ng-container matColumnDef="actions">
                    <th id="actions" mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
                    <td mat-cell *matCellDef="let group">
                        <button mat-icon-button aria-label="Delete" (click)="deleteGroup($event, group.id)" style="font-size: 15px;">
              <mat-icon>delete</mat-icon>
            </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>
            <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
        </div>
    </div>


    <div *ngIf="openGroupForm">
        <div class="sticky-top">
            <div class="Tabletitle">{{dialogData.title}}</div>
        </div>
        <div class="card-body">
            <div class="input-group-sm mb-3 input-group col-6">
                <div class="input-group-prepend">
                    <span class="input-group-text">Name</span>
                </div>
                <input class="form-control" type="text" [(ngModel)]="dialogData.name">
            </div>

            <div class="input-group-sm mb-3 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text">Description</span>
                </div>
                <textarea class="form-control" type="text" [(ngModel)]="dialogData.description"></textarea>
            </div>

            <button mat-raised-button *ngIf="dialogData.button=='Create'" class="actionButton m-3" (click)="createGroupButton()">{{dialogData.button}}</button>

            <button mat-raised-button class="backButton m-2" (click)="back()">Back</button>
        </div>
    </div>
</div>